import React, { lazy, Suspense, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import htmlParser from "html-react-parser";
import { formatInTimeZone } from "date-fns-tz";
import "../Body/Body.css";

export default function Body({ bannerData, links }) {
  const imgCDNURL = process.env.REACT_APP_SEPTEMBER_CDN_URL;
  return (
    <>
      <div className="banner">
        <Container>
          <Row>
            <Col>

              <div className="bannertextdesktop">
                <div>
                  <a
                    href={"https://www.swmc.com/"}
                    target="_blank"
                    rel="noopener noreferrer"

                  >
                    <img
                      src={process.env.REACT_APP_CDN_LINK + "swmc-images/sunwest-trust-white-logo.png"}
                      className="sunwestlogo"
                      title="SunWest-Logo"
                    ></img>
                  </a>
                </div>
                <p>{htmlParser(bannerData.mastermindbannerheading)}</p>
              </div>
              <div className="bannertextsub">
                <p>{htmlParser(bannerData.mastermindsubheading1)}</p>
              </div>
              <div className="bannertextsubpara">
                <p>{htmlParser(bannerData.mastermindsubheading2)}</p>
              </div>

              <img
                src={imgCDNURL + "bannerbgmobilenew.webp"}
                className="mobilegroup"
              ></img>
            </Col>
          </Row>
          <Col>
            <div className="editionbox">
              <div className="edition">
                <p className="textedition">
                  {" "}
                  {htmlParser(bannerData.monthedition)}
                </p>
              </div>
            </div>
          </Col>
        </Container>
        <div className="editionmobilebox">
          <p className="editionmobiletext">
            {" "}
            {htmlParser(bannerData.monthedition)}
          </p>

        </div>
      </div>

    </>
  );
}
